import { render } from "./postReport.vue?vue&type=template&id=737d8d7c"
import script from "./postReport.vue?vue&type=script&lang=js"
export * from "./postReport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__